import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../../environments/environment";
import {MathsNaive} from "../../../classes/maths/maths-naive";
import {StatesService} from "../../state/states.service";

@Injectable({
    providedIn: 'root'
})
export class MathsNaiveService {

    constructor(private http: HttpClient,private statesService: StatesService) {
    }

    getProjectList(active: boolean) {
        let activeNumber: number = active === true ? 1 : 0;
        return this.http.get(`projects?active=` + activeNumber  + `&level=` + this.statesService.stateLevel);

    }

    getProject(id: number, view: string) {
        return this.http.get(`projects/` + id + `?groups=` + view);
    }

    postSubscription(mathsNaive: MathsNaive) {
        return this.http.post(`projects/abo-maths`, mathsNaive);
    }

    patchSubscription(id: number, mathsNaive: MathsNaive) {
        return this.http.patch(`projects/` + id + `/abo-maths`, mathsNaive);
    }

    deleteSubscription(id: number) {
        return this.http.delete(`projects/` + id + `/abo-maths`);
    }


    getCsvRecap(project: any) {

      //  return this.http.get(`export/thermal-correction-recap/csv?projects=` + projects.id);

        return window.open(environment.apiUrl + environment.guardedRoute + `export/thermal-correction-recap/csv?project=` + project.id, '_blank');

    }

    getCsvOneLocation(project: any, id_location: number) {
        let start = project.start_date.split('+');
        let end = project.end_date.split('+');
        return window.open(environment.apiUrl + environment.guardedRoute + `export/thermal-correction/csv?dateStart=` + start[0] + `&dateEnd=` + end[0] + `&location=` + id_location , '_blank');
    }


}
